import { render, staticRenderFns } from "./orgIndex.vue?vue&type=template&id=77a8919f&"
import script from "./orgIndex.vue?vue&type=script&lang=js&"
export * from "./orgIndex.vue?vue&type=script&lang=js&"
import style0 from "./orgIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports